import { useState } from "react";
import { Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom"; // ✅ Use Link instead of useNavigate

export default function MainModels({ data, activeIndex }) {
  const [hoverIndex, setHoverIndex] = useState(null);

  // Map names to route paths
  const routeMap = {
    "OCEAN Model": "/ocean",
    "Bar-On Model": "/baronmodel",
    "RIASEC Model": "/riasec",
    "CORE Formula": "/core",
    "DAT Framework": "/dat"
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", maxWidth: "100%" }}>
      {data.map((item, index) => {
        const isHighlighted = hoverIndex === index || (hoverIndex === null && activeIndex === index);
        const routePath = routeMap[item.mainmodelname]; // ✅ Get path from map

        return (
          <Link to={routePath} key={index} style={{ textDecoration: "none" }}>
            <Paper
              elevation={6}
              onMouseEnter={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(null)}
              sx={{
                background: isHighlighted
                  ? "linear-gradient(180deg, #FFCD4A 0%, #F6A72A 100%)"
                  : "#fff",
                width: "225px",
                height: "95px",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 20px",
                marginRight: "15px",
                transition: "all 0.3s ease-in-out",
                cursor: "pointer",
                transform: isHighlighted ? "scale(1.1)" : "scale(1)",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  color: isHighlighted ? "#fff" : "#000",
                  textAlign: "center"
                }}
              >
                {item.mainmodelname}
              </Typography>
            </Paper>
          </Link>
        );
      })}
    </div>
  );
}
